var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ButtonGroup, Checkbox, Divider, FormControlLabel, Grid, IconButton, TextField, Typography, styled } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid-premium";
import { t } from "i18next";
import { useEffect, useRef, useState } from "react";
import { UploadImage } from "../../../api/api";
import { Config } from "../../../api/config";
import { deleteAllJobCardAttachmentsUrl, getDownloadJobCardDocumentAttachmentUrl, jobCardAttachmentCreateUrl } from "../../../api/url";
import { GalleryIcon } from "../../../assets/customIcons";
import { ApproveSqaureIcon, ApproveSqaureIconGreen, DeleteButtonNewIcon, RejectIcon, RejectSquareIcon } from "../../../assets/images";
import { AudioPlayer, MuiButton, MuiPopup, MuiStack } from "../../../components";
import { MuiIconButton } from "../../../components/atoms/iconButtonComponent";
import { MuiImagePopUp } from "../../../components/atoms/imageDialogBox";
import { MuiLoaderButton } from "../../../components/atoms/loaderButton";
import SkeletonLoader from "../../../components/atoms/sketeton";
import ViewAllImagePopUp from "../../../components/atoms/viewAllImagePopUp";
import { NoRowsOverlay } from "../../../components/molecules/dataGridComponent";
import { AudioComponent } from "../../../components/templates/translateToJob/audioRecorder";
import ImageCapture from "../../../components/templates/translateToJob/imageCapture";
import { EFIChecklistParent, Module, isModuleConfig } from "../../../constants";
import { downloadAttachment, showLoader, showNotification } from "../../../redux/commonSlice";
import { createAPI, getByIdAPI, getListAPI, setState } from "../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { bajajPrimaryBlue } from "../../../theme/palette";
import { systemColor } from "../../../theme/systemColor";
import useAnalyticsEventTracker from "../../../utils/useAnalyticsEventTracker";
import { sortImagesByTimeStamp } from "../../../utils/utils";
var StyledStack = styled(MuiStack, {
    shouldForwardProp: function (prop) { return prop !== "openRejectActions"; }
})(function (_ref) {
    var theme = _ref.theme, openRejectActions = _ref.openRejectActions, isApproved = _ref.isApproved;
    return {
        backgroundColor: openRejectActions ? '#FFF1F0' : isApproved ? '#F6FFED' : 'none',
        border: "1px solid ".concat(openRejectActions ? "#CF1322" : isApproved ? '#52C41A' : "#DEE4EB"),
        borderRadius: '8px'
    };
});
var FinalInspectorAdditionalJobs = function (props) {
    var _documentDetailsGetBy, _documentDetailsGetBy2, _commonRejectionAudio, _currentSelectedItem$2;
    var trackButtonClick = useAnalyticsEventTracker("FinalInspectorAdditionalJobs");
    var callApIStatus = props.callApIStatus, paramKey = props.paramKey, parentComponent = props.parentComponent, isViewOnly = props.isViewOnly, jobCardId = props.jobCardId, showOnlyRejectedItems = props.showOnlyRejectedItems;
    // const { jobCardId } = useParams();
    var _a = useAppSelector(function (state) { return state.crud; }), documentDetailsGetById = _a.documentDetailsGetById, FinalInspectionChecklistCount = _a.FinalInspectionChecklistCount, FIChecklistItemChange = _a.FIChecklistItemChange;
    var dispatch = useAppDispatch();
    var fileInputRef = useRef(null);
    var _b = useState([]), complaintsList = _b[0], setComplaintsList = _b[1];
    var _c = useState(false), isSelectAll = _c[0], setIsSelectAll = _c[1];
    var _d = useState(false), selectMode = _d[0], setSelectMode = _d[1];
    var _e = useState(false), openImageGallery = _e[0], setOpenImageGallery = _e[1];
    var _f = useState(null), currentSelectedItem = _f[0], setCurrentSelectedItem = _f[1];
    var _g = useState(false), isOpenRejectAllPopup = _g[0], setIsOpenRejectAllPopup = _g[1];
    var _h = useState(false), isDrawerOpen = _h[0], setISDrawerOpen = _h[1];
    var _j = useState(null), isRejectPhotoView = _j[0], setIsRejectPhotoView = _j[1];
    var _k = useState(true), isShowSkeleton = _k[0], setShowSkeleton = _k[1];
    var _l = useState(""), imageURL = _l[0], setImageURL = _l[1];
    var _m = useState(false), viewImages = _m[0], setViewImages = _m[1];
    var _o = useState([]), viewAllImagesList = _o[0], setViewAllImagesList = _o[1];
    var _p = useState(false), openCommonImagePopup = _p[0], setOpenCommonImagePopup = _p[1];
    var _q = useState(""), commonRejectionComment = _q[0], setCommonRejectionComment = _q[1];
    var _r = useState([]), commonRejectionPhotos = _r[0], setCommonRejectionPhotos = _r[1];
    var _s = useState({
        commonRejectionAudioUrl: "",
        commonRejectionAudioDuration: 0
    }), commonRejectionAudio = _s[0], setCommonRejectionAudio = _s[1];
    var _t = useState(true), disableSaveButton = _t[0], setDisableSaveButton = _t[1];
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var isInspectionMode = true;
    useEffect(function () {
        if (callApIStatus) {
            initiate();
        }
        return function () {
            setComplaintsList([]);
        };
    }, [callApIStatus]);
    var initiate = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            getAdditionalJobsList();
            return [2 /*return*/];
        });
    }); };
    var getSavedAdditionalJobsList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var body, answersResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        JobCardId: jobCardId,
                        Key: paramKey
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "JobCardDetailFinalInspectionResponse/JobCardDetailFIResponse"),
                            request: body
                        }))];
                case 1:
                    answersResponse = _a.sent();
                    if (answersResponse.payload.success && Array.isArray(answersResponse.payload.data)) {
                        return [2 /*return*/, answersResponse.payload.data];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getAdditionalJobsList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _additionalJobResult$, payload, additionalJobResult, _additionalJobResult$2, savedJobsResult_1, masterList, finalList_1, listPromise, sortedList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    payload = {
                        JobCardId: jobCardId,
                        Key: paramKey
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "JobCardDetail/ByKey"),
                            request: payload
                        }))];
                case 1:
                    additionalJobResult = _a.sent();
                    if (!(additionalJobResult.payload.success && (_additionalJobResult$ = additionalJobResult.payload.data) !== null && _additionalJobResult$ !== void 0 && _additionalJobResult$.Jobs)) return [3 /*break*/, 4];
                    return [4 /*yield*/, getSavedAdditionalJobsList()];
                case 2:
                    savedJobsResult_1 = _a.sent();
                    masterList = (_additionalJobResult$2 = additionalJobResult.payload.data) === null || _additionalJobResult$2 === void 0 ? void 0 : _additionalJobResult$2.Jobs;
                    finalList_1 = [];
                    listPromise = masterList === null || masterList === void 0 ? void 0 : masterList.map(function (masterItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var matchedItem, _masterItem$ChildName, _downloadedAttachment, _downloadedAttachment2, downloadedAttachments, updatedItem, _masterItem$ChildName2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    matchedItem = savedJobsResult_1.find(function (savedItem) { return savedItem.JobCardDetailId === masterItem.JobCardDetailId; });
                                    if (!matchedItem) return [3 /*break*/, 2];
                                    return [4 /*yield*/, getDownloadImageForFIDetailsChecklist(matchedItem.ImageAttachments)];
                                case 1:
                                    downloadedAttachments = _a.sent();
                                    updatedItem = _objectSpread(_objectSpread({}, masterItem), {}, {
                                        ResponseValue: matchedItem.Value ? matchedItem.Value : '',
                                        isAprroved: matchedItem.Value ? matchedItem.Value === "true" : false,
                                        isRejected: matchedItem.Value ? matchedItem.Value === "false" : false,
                                        openRejectActions: matchedItem.Value ? matchedItem.Value === "false" : false,
                                        rejectionComment: matchedItem.Comments ? matchedItem.Comments : "",
                                        isSelected: false,
                                        Title: (_masterItem$ChildName = masterItem.ChildName) !== null && _masterItem$ChildName !== void 0 ? _masterItem$ChildName : "",
                                        rejectionPhotos: downloadedAttachments.imageAttachementURLs,
                                        rejectionAudio: downloadedAttachments.audioAttachementURLs && downloadedAttachments.audioAttachementURLs.length > 0 ? downloadedAttachments.audioAttachementURLs[0].audioBlobUrl : "",
                                        rejectionAudioDuration: 0,
                                        rejectionAudioAttachmentId: ((_downloadedAttachment = downloadedAttachments.audioAttachementURLs) === null || _downloadedAttachment === void 0 ? void 0 : _downloadedAttachment.length) > 0 ? downloadedAttachments.audioAttachementURLs[0].attachmentId : "",
                                        isAudioAlreadyUploaded: ((_downloadedAttachment2 = downloadedAttachments.audioAttachementURLs) === null || _downloadedAttachment2 === void 0 ? void 0 : _downloadedAttachment2.length) > 0 ? downloadedAttachments.audioAttachementURLs[0].isAlreadyUploaded : false
                                    });
                                    finalList_1.push(updatedItem);
                                    return [3 /*break*/, 3];
                                case 2:
                                    finalList_1.push(_objectSpread(_objectSpread({}, masterItem), {}, {
                                        ResponseValue: "",
                                        isAprroved: false,
                                        isRejected: false,
                                        openRejectActions: false,
                                        rejectionComment: "",
                                        isSelected: false,
                                        Title: (_masterItem$ChildName2 = masterItem.ChildName) !== null && _masterItem$ChildName2 !== void 0 ? _masterItem$ChildName2 : "",
                                        rejectionPhotos: [],
                                        isAudioAlreadyUploaded: false
                                    }));
                                    _a.label = 3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); });
                    setShowSkeleton(false);
                    return [4 /*yield*/, Promise.all(listPromise)];
                case 3:
                    _a.sent();
                    sortedList = finalList_1.sort(function (a, b) {
                        if ((a === null || a === void 0 ? void 0 : a.Title) < (b === null || b === void 0 ? void 0 : b.Title)) {
                            return -1;
                        }
                        if ((a === null || a === void 0 ? void 0 : a.Title) > (b === null || b === void 0 ? void 0 : b.Title)) {
                            return 1;
                        }
                        return 0;
                    });
                    if (showOnlyRejectedItems) {
                        sortedList = sortedList.filter(function (item) { return item.isRejected; });
                    }
                    setComplaintsList(sortedList);
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getDownloadImageForFIDetailsChecklist = function (ImageAttachments) { return __awaiter(void 0, void 0, void 0, function () {
        var imageAttachementURLs, audioAttachementURLs, imageAttachmentsUrlWithMediaType1, downloadPromise, audioAttachmentsUrlWithMediaType2, downloadPromise1, sortedImages, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    imageAttachementURLs = [];
                    audioAttachementURLs = [];
                    imageAttachmentsUrlWithMediaType1 = ImageAttachments.filter(function (item) { return item.MediaType === 1; });
                    downloadPromise = imageAttachmentsUrlWithMediaType1.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var base64, error_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 4];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, imageItem.id, getDownloadJobCardDocumentAttachmentUrl)];
                                case 2:
                                    base64 = _a.sent();
                                    imageAttachementURLs.push({
                                        blobUrl: base64,
                                        file: null,
                                        isAlreadyUploaded: true,
                                        attachmentId: imageItem.AttachmentId,
                                        _ts: imageItem._ts
                                    });
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_2 = _a.sent();
                                    console.error(error_2);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    audioAttachmentsUrlWithMediaType2 = ImageAttachments.filter(function (item) { return item.MediaType === 2; });
                    downloadPromise1 = audioAttachmentsUrlWithMediaType2.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var base64, error_3;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 4];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, imageItem.id, getDownloadJobCardDocumentAttachmentUrl)];
                                case 2:
                                    base64 = _a.sent();
                                    audioAttachementURLs.push({
                                        audioBlobUrl: base64,
                                        file: null,
                                        isAlreadyUploaded: true,
                                        attachmentId: imageItem.AttachmentId
                                    });
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_3 = _a.sent();
                                    console.error(error_3);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, Promise.all(downloadPromise)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, Promise.all(downloadPromise1)];
                case 3:
                    _a.sent();
                    sortedImages = sortImagesByTimeStamp(imageAttachementURLs);
                    return [2 /*return*/, {
                            imageAttachementURLs: sortedImages,
                            audioAttachementURLs: audioAttachementURLs
                        }];
                case 4:
                    error_1 = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    console.error(error_1);
                    return [2 /*return*/, {
                            imageAttachementURLs: [],
                            audioAttachementURLs: []
                        }];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var onClickApproveIcon = function (index) {
        var updatedComplaintList = __spreadArray([], complaintsList, true);
        updatedComplaintList[index].isAprroved = true;
        updatedComplaintList[index].isRejected = false;
        updatedComplaintList[index].openRejectActions = false;
        updatedComplaintList[index].rejectionAudio = "";
        updatedComplaintList[index].rejectionAudioAttachmentId = "";
        updatedComplaintList[index].rejectionAudioDuration = "";
        updatedComplaintList[index].rejectionComment = "";
        updatedComplaintList[index].rejectionPhotos = [];
        setComplaintsList(updatedComplaintList);
        setDisableSaveButton(false);
    };
    var onClickRejectIcon = function (index) {
        var updatedComplaintList = __spreadArray([], complaintsList, true);
        updatedComplaintList[index].isRejected = true;
        updatedComplaintList[index].isAprroved = false;
        updatedComplaintList[index].openRejectActions = !updatedComplaintList[index].openRejectActions;
        // updatedComplaintList.map((complaint) => {
        //     if (complaint.QuestionId !== updatedComplaintList[index].QuestionId) {
        //         for (let item of Object.keys(complaint)) {
        //             if (item === 'openRejectActions') {
        //                 complaint.openRejectActions = false
        //             }
        //         }
        //     }
        // })
        setComplaintsList(updatedComplaintList);
        setDisableSaveButton(false);
    };
    var getAllComplaintsStatus = function () {
        var approvedComplaints = complaintsList.filter(function (item) { return item.isAprroved; });
        var rejectedComplaints = complaintsList.filter(function (item) { return item.isRejected; });
        return {
            isAllApproved: approvedComplaints.length === complaintsList.length,
            isAllRejected: rejectedComplaints.length === complaintsList.length
        };
    };
    var handleComplaintData = function (data, index) {
        var updatedComplaintList = __spreadArray([], complaintsList, true);
        updatedComplaintList[index].isRejected = true;
        updatedComplaintList[index].isAprroved = false;
        updatedComplaintList[index].rejectionComment = data.discription;
        // updatedComplaintList[index].openRejectActions = !updatedComplaintList[index].openRejectActions
        // updatedComplaintList.map((complaint) => {
        //     if (complaint.QuestionId !== updatedComplaintList[index].QuestionId) {
        //         for (let item of Object.keys(complaint)) {
        //             if (item === 'openRejectActions') {
        //                 complaint.openRejectActions = false
        //             }
        //         }
        //     }
        // })
        setComplaintsList(updatedComplaintList);
        setDisableSaveButton(false);
    };
    var handleApproveAllComplaints = function () {
        var updatedComplaintList = __spreadArray([], complaintsList, true);
        updatedComplaintList.map(function (complaint) {
            complaint.isAprroved = true;
            complaint.isRejected = false;
            complaint.openRejectActions = false;
            complaint.rejectionAudio = "";
            complaint.rejectionAudioAttachmentId = "";
            complaint.rejectionAudioDuration = "";
            complaint.rejectionComment = "";
            complaint.rejectionPhotos = [];
        });
        setComplaintsList(updatedComplaintList);
        setSelectMode(false);
        setDisableSaveButton(false);
    };
    var handleRejectAllComplaints = function () {
        setIsOpenRejectAllPopup(true);
    };
    var handleCloseRejectAllPopup = function () {
        setIsOpenRejectAllPopup(false);
    };
    var handleRejectAllPopupDataRecieved = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updatedComplaintList, updatedList, listPromise;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatedComplaintList = __spreadArray([], complaintsList, true);
                    updatedList = [];
                    listPromise = updatedComplaintList.map(function (complaint) { return __awaiter(void 0, void 0, void 0, function () {
                        var rejectionPhotosList;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, handleRejectAllImageList(complaint)];
                                case 1:
                                    rejectionPhotosList = _a.sent();
                                    updatedList.push(_objectSpread(_objectSpread({}, complaint), {}, {
                                        isAprroved: false,
                                        isRejected: true,
                                        openRejectActions: true,
                                        rejectionComment: commonRejectionComment,
                                        rejectionAudio: commonRejectionAudio.commonRejectionAudioUrl,
                                        rejectionAudioAttachmentId: "",
                                        rejectionAudioDuration: commonRejectionAudio.commonRejectionAudioDuration,
                                        rejectionPhotos: rejectionPhotosList !== null && rejectionPhotosList !== void 0 ? rejectionPhotosList : []
                                    }));
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(listPromise)];
                case 1:
                    _a.sent();
                    setComplaintsList(updatedList);
                    handleCloseRejectAllPopup();
                    setDisableSaveButton(false);
                    setSelectMode(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleItemCheckboxClick = function (index) {
        var updatedComplaintList = __spreadArray([], complaintsList, true);
        updatedComplaintList[index].isSelected = !updatedComplaintList[index].isSelected;
        setComplaintsList(updatedComplaintList);
    };
    var handleSelectAllClick = function () {
        var updatedComplaintList = __spreadArray([], complaintsList, true);
        updatedComplaintList.map(function (complaint) {
            complaint.isSelected = !isSelectAll;
        });
        setComplaintsList(updatedComplaintList);
        setIsSelectAll(!isSelectAll);
        setSelectMode(!selectMode);
    };
    var getSelectAllStatus = function () {
        var selectedComplaints = complaintsList.filter(function (item) { return item.isSelected; });
        return selectedComplaints.length === complaintsList.length;
    };
    var saveDynamicChecklistValues = function () { return __awaiter(void 0, void 0, void 0, function () {
        var FilledValues, _saveFormValuesRespon, requestBody, saveFormValuesResponse, totalCount, approvedCount, rejectedCount, updatedFICounts, updatedItem, updatedItem, updatedItem, updatedFIChecklistChangeDetails, updatedItem, updatedItem, updatedItem;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trackButtonClick("ButtonClickEvent", "FI_Additional_Jobs_Save", undefined);
                    FilledValues = [];
                    if (!(complaintsList && complaintsList.length > 0)) return [3 /*break*/, 2];
                    complaintsList.map(function (questionItem) {
                        var imageAttachmentPayload = [];
                        if (questionItem.rejectionPhotos && questionItem.rejectionPhotos.length > 0) {
                            questionItem.rejectionPhotos.map(function (imageItem) {
                                imageAttachmentPayload.push({
                                    AttachmentId: imageItem.attachmentId,
                                    MediaType: 1,
                                    SystemName: "JobCardDetail"
                                });
                            });
                        }
                        if (questionItem.rejectionAudio && questionItem.rejectionAudioAttachmentId) {
                            imageAttachmentPayload.push({
                                AttachmentId: questionItem.rejectionAudioAttachmentId,
                                MediaType: 2,
                                SystemName: "JobCardDetail"
                            });
                        }
                        var checkValue = "";
                        if (questionItem.isRejected && !questionItem.isAprroved) {
                            checkValue = "false";
                        }
                        if (!questionItem.isRejected && questionItem.isAprroved) {
                            checkValue = "true";
                        }
                        FilledValues.push({
                            JobCardDetailId: questionItem.JobCardDetailId,
                            Value: checkValue,
                            Comments: questionItem.isRejected ? questionItem.rejectionComment : "",
                            RecordedDateTime: new Date(),
                            ImageAttachments: imageAttachmentPayload
                        });
                    });
                    requestBody = {
                        JobCardId: jobCardId,
                        Response: FilledValues
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "JobCardDetailFinalInspectionResponse/Upsert"),
                            request: requestBody
                        }))];
                case 1:
                    saveFormValuesResponse = _a.sent();
                    if ((_saveFormValuesRespon = saveFormValuesResponse.payload.value) !== null && _saveFormValuesRespon !== void 0 && _saveFormValuesRespon.success) {
                        setDisableSaveButton(true);
                        setCommonRejectionComment("");
                        setCommonRejectionAudio({
                            commonRejectionAudioUrl: "",
                            commonRejectionAudioDuration: 0
                        });
                        setCommonRejectionPhotos([]);
                        totalCount = complaintsList.length;
                        approvedCount = complaintsList.filter(function (item) { return !item.isRejected && item.isAprroved; }).length;
                        rejectedCount = totalCount - approvedCount;
                        updatedFICounts = _objectSpread({}, FinalInspectionChecklistCount);
                        if (parentComponent === EFIChecklistParent.AdditionalJobs) {
                            updatedItem = _objectSpread({}, updatedFICounts.additionalJobs);
                            updatedItem.approvedCount = approvedCount;
                            updatedItem.totalCount = totalCount;
                            updatedItem.rejectedCount = rejectedCount;
                            updatedFICounts.additionalJobs = updatedItem;
                        }
                        if (parentComponent === EFIChecklistParent.StandaredJobs) {
                            updatedItem = _objectSpread({}, updatedFICounts.standardJobs);
                            updatedItem.approvedCount = approvedCount;
                            updatedItem.totalCount = totalCount;
                            updatedItem.rejectedCount = rejectedCount;
                            updatedFICounts.standardJobs = updatedItem;
                        }
                        if (parentComponent === EFIChecklistParent.PeriodicMaintenance) {
                            updatedItem = _objectSpread({}, updatedFICounts.periodicMaintanance);
                            updatedItem.approvedCount = approvedCount;
                            updatedItem.totalCount = totalCount;
                            updatedItem.rejectedCount = rejectedCount;
                            updatedFICounts.periodicMaintanance = updatedItem;
                        }
                        updatedFIChecklistChangeDetails = _objectSpread({}, FIChecklistItemChange);
                        if (parentComponent === EFIChecklistParent.AdditionalJobs) {
                            updatedItem = _objectSpread({}, updatedFIChecklistChangeDetails.additionalJobs);
                            updatedItem.isItemRejected = rejectedCount > 0;
                            updatedItem.isSaveClick = true;
                            updatedFIChecklistChangeDetails.additionalJobs = updatedItem;
                        }
                        if (parentComponent === EFIChecklistParent.StandaredJobs) {
                            updatedItem = _objectSpread({}, updatedFIChecklistChangeDetails.standardJobs);
                            updatedItem.isItemRejected = rejectedCount > 0;
                            updatedItem.isSaveClick = true;
                            updatedFIChecklistChangeDetails.standardJobs = updatedItem;
                        }
                        if (parentComponent === EFIChecklistParent.PeriodicMaintenance) {
                            updatedItem = _objectSpread({}, updatedFIChecklistChangeDetails.periodicMaintanance);
                            updatedItem.isItemRejected = rejectedCount > 0;
                            updatedItem.isSaveClick = true;
                            updatedFIChecklistChangeDetails.periodicMaintanance = updatedItem;
                        }
                        dispatch(setState({
                            key: "FinalInspectionChecklistCount",
                            value: updatedFICounts
                        }));
                        dispatch(setState({
                            key: "FIChecklistItemChange",
                            value: updatedFIChecklistChangeDetails
                        }));
                        dispatch(showNotification({
                            isOpen: true,
                            message: "".concat(parentComponent, " saved successfully"),
                            type: "success"
                        }));
                    }
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    // buttonClickSpan.end();
                    // pageLoadSpan.end();
                    // transaction.end();
                    return [2 /*return*/, saveFormValuesResponse];
                case 2: return [2 /*return*/, false];
            }
        });
    }); };
    var handleOpenGalleryClick = function (item) {
        // let _jobItem: any = [...jobItemList]
        // const galleryAndCamera = _jobItem.map((item: any) =>
        //     item.ComplaintId === items.ComplaintId ? { ...item, isOpenCameraandGallery: !item.isOpenCameraandGallery } : item
        // );
        // setJobItemList(galleryAndCamera)
        // onChange(galleryAndCamera, groupItem);
        setCurrentSelectedItem(item);
        setOpenImageGallery(function (prev) { return !prev; });
    };
    var handleImageList = function (imagesList, removedImageList) { return __awaiter(void 0, void 0, void 0, function () {
        var imagesToBeUpload, ImageAttachmentsBody_1, requestBody, ResponseData, jobCardDocumentAttachmentIds, imageAttachmentsWithMediaType1_1, uploadPromises, deletePromise, updatedImagesList, uniqueAttachmentIds, newArray, updatedList, urlconfirmation;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    imagesToBeUpload = [];
                    imagesToBeUpload = imagesList.filter(function (item) { return !item.attachmentId && !item.isAlreadyUploaded; });
                    if (!(imagesToBeUpload.length > 0)) return [3 /*break*/, 3];
                    ImageAttachmentsBody_1 = [];
                    imagesToBeUpload.map(function (imageItem) {
                        if (!imageItem.isAlreadyUploaded) {
                            ImageAttachmentsBody_1.push({
                                SystemName: "JobCardDetail",
                                MediaType: 1
                            });
                        }
                    });
                    requestBody = {
                        ParentId: currentSelectedItem === null || currentSelectedItem === void 0 ? void 0 : currentSelectedItem.JobCardDetailId,
                        ImageAttachments: ImageAttachmentsBody_1
                    };
                    return [4 /*yield*/, dispatch(createAPI({
                            key: '',
                            url: jobCardAttachmentCreateUrl,
                            request: requestBody
                        }))];
                case 1:
                    ResponseData = _a.sent();
                    jobCardDocumentAttachmentIds = [];
                    if (ResponseData.payload.success && ResponseData.payload.data) {
                        jobCardDocumentAttachmentIds = ResponseData.payload.data;
                    }
                    imageAttachmentsWithMediaType1_1 = jobCardDocumentAttachmentIds.filter(function (item) { return item.MediaType === 1; });
                    uploadPromises = imagesToBeUpload.map(function (imageItem, index) { return __awaiter(void 0, void 0, void 0, function () {
                        var matchingAttachment, attachmentId;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(!imageItem.attachmentId && !imageItem.isAlreadyUploaded)) return [3 /*break*/, 2];
                                    matchingAttachment = imageAttachmentsWithMediaType1_1[index];
                                    return [4 /*yield*/, uploadAttachment(imageItem.file, matchingAttachment.JobCardDocumentAttachmentId)];
                                case 1:
                                    attachmentId = _a.sent();
                                    imageItem.attachmentId = attachmentId;
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(uploadPromises)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    deletePromise = removedImageList.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var _currentSelectedItem$, request, DeleteAttchementResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!imageItem.isAlreadyUploaded) return [3 /*break*/, 2];
                                    request = {
                                        "SystemName": "JobCardDetail",
                                        ParentId: (_currentSelectedItem$ = currentSelectedItem === null || currentSelectedItem === void 0 ? void 0 : currentSelectedItem.JobCardDetailId) !== null && _currentSelectedItem$ !== void 0 ? _currentSelectedItem$ : "",
                                        AttachmentId: imageItem.attachmentId
                                    };
                                    return [4 /*yield*/, dispatch(getListAPI({
                                            key: "",
                                            url: deleteAllJobCardAttachmentsUrl,
                                            request: request
                                        }))];
                                case 1:
                                    DeleteAttchementResponse = _a.sent();
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(deletePromise)];
                case 4:
                    _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    updatedImagesList = __spreadArray(__spreadArray([], imagesToBeUpload, true), imagesList, true);
                    uniqueAttachmentIds = {};
                    updatedImagesList.forEach(function (item) {
                        uniqueAttachmentIds[item.attachmentId] = item;
                    });
                    newArray = Object.values(uniqueAttachmentIds);
                    updatedList = __spreadArray([], complaintsList, true);
                    urlconfirmation = updatedList.map(function (item) { return item.JobCardDetailId === (currentSelectedItem === null || currentSelectedItem === void 0 ? void 0 : currentSelectedItem.JobCardDetailId) ? _objectSpread(_objectSpread({}, item), {}, {
                        rejectionPhotos: newArray
                    }) : item; });
                    setComplaintsList(urlconfirmation);
                    setDisableSaveButton(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleRejectAllImageList = function (complaint) { return __awaiter(void 0, void 0, void 0, function () {
        var imagesToBeUpload, ImageAttachmentsBody_2, requestBody, ResponseData, jobCardDocumentAttachmentIds, imageAttachmentsWithMediaType1_2, updloadedImageList_1, uploadPromises, uniqueAttachmentIds_1, newArray, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    imagesToBeUpload = [];
                    imagesToBeUpload = commonRejectionPhotos.filter(function (item) { return !item.attachmentId && !item.isAlreadyUploaded; });
                    if (!(imagesToBeUpload.length > 0)) return [3 /*break*/, 5];
                    ImageAttachmentsBody_2 = [];
                    imagesToBeUpload.map(function (imageItem) {
                        if (!imageItem.isAlreadyUploaded) {
                            ImageAttachmentsBody_2.push({
                                SystemName: "JobCardDetail",
                                MediaType: 1
                            });
                        }
                    });
                    requestBody = {
                        ParentId: complaint === null || complaint === void 0 ? void 0 : complaint.JobCardDetailId,
                        ImageAttachments: ImageAttachmentsBody_2
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, dispatch(createAPI({
                            key: '',
                            url: jobCardAttachmentCreateUrl,
                            request: requestBody
                        }))];
                case 2:
                    ResponseData = _a.sent();
                    jobCardDocumentAttachmentIds = [];
                    if (ResponseData.payload.success && ResponseData.payload.data) {
                        jobCardDocumentAttachmentIds = ResponseData.payload.data;
                    }
                    imageAttachmentsWithMediaType1_2 = jobCardDocumentAttachmentIds.filter(function (item) { return item.MediaType === 1; });
                    updloadedImageList_1 = [];
                    uploadPromises = imagesToBeUpload.map(function (imageItem, index) { return __awaiter(void 0, void 0, void 0, function () {
                        var matchingAttachment, attachmentId;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(!imageItem.attachmentId && !imageItem.isAlreadyUploaded)) return [3 /*break*/, 2];
                                    matchingAttachment = imageAttachmentsWithMediaType1_2[index];
                                    return [4 /*yield*/, uploadAttachment(imageItem.file, matchingAttachment.JobCardDocumentAttachmentId)];
                                case 1:
                                    attachmentId = _a.sent();
                                    updloadedImageList_1.push(_objectSpread(_objectSpread({}, imageItem), {}, {
                                        attachmentId: attachmentId
                                    }));
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(uploadPromises)];
                case 3:
                    _a.sent();
                    uniqueAttachmentIds_1 = {};
                    updloadedImageList_1.forEach(function (item) {
                        uniqueAttachmentIds_1[item.attachmentId] = item;
                    });
                    newArray = Object.values(uniqueAttachmentIds_1);
                    return [2 /*return*/, newArray];
                case 4:
                    error_4 = _a.sent();
                    console.error("error", error_4);
                    return [2 /*return*/, []];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleAudioUrl = function (blobUrl, duration, convertedBlob, items, index) {
        uploadAudio(blobUrl, duration, convertedBlob, items, index);
    };
    var uploadAttachment = function (image, attachmentId) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, result, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    formData = new FormData();
                    formData.append('data', image);
                    return [4 /*yield*/, UploadImage("".concat(Config.baseURL, "resource/JobCardDocumentAttachment/").concat(attachmentId), formData, "BlankSystemName", dispatch)];
                case 1:
                    result = _a.sent();
                    if (result.success) {
                        return [2 /*return*/, result.attachmentId];
                    }
                    else {
                        return [2 /*return*/, ""];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_5 = _a.sent();
                    console.error("Error uploading image:", error_5);
                    return [2 /*return*/, ""];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var uploadAudio = function (blobUrl, duration, convertedBlob, item, index) { return __awaiter(void 0, void 0, void 0, function () {
        var convertedBlobUrl;
        return __generator(this, function (_a) {
            convertedBlobUrl = URL.createObjectURL(convertedBlob);
            // Fetch the Blob data
            fetch(convertedBlobUrl).then(function (response) { return response.blob(); }).then(function (blob) { return __awaiter(void 0, void 0, void 0, function () {
                var mp3File, audioAttachmentsBody, requestBody, ResponseData, jobCardDocumentAttachmentIds, imageAttachmentsWithMediaType2, audioAttachmentId_1, updatedList, urlconfirmation;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            mp3File = new File([blob], "audio-".concat(new Date().toISOString(), ".mp3"), {
                                type: 'audio/mpeg'
                            });
                            audioAttachmentsBody = [];
                            audioAttachmentsBody.push({
                                SystemName: "JobCardDetail",
                                MediaType: 2
                            });
                            requestBody = {
                                ParentId: item === null || item === void 0 ? void 0 : item.JobCardDetailId,
                                ImageAttachments: audioAttachmentsBody
                            };
                            return [4 /*yield*/, dispatch(createAPI({
                                    key: '',
                                    url: jobCardAttachmentCreateUrl,
                                    request: requestBody
                                }))];
                        case 1:
                            ResponseData = _a.sent();
                            jobCardDocumentAttachmentIds = [];
                            if (!(ResponseData.payload.success && ResponseData.payload.data)) return [3 /*break*/, 3];
                            jobCardDocumentAttachmentIds = ResponseData.payload.data;
                            imageAttachmentsWithMediaType2 = jobCardDocumentAttachmentIds.filter(function (item) { return item.MediaType === 2; });
                            if (!(imageAttachmentsWithMediaType2.length > 0)) return [3 /*break*/, 3];
                            return [4 /*yield*/, uploadAttachment(mp3File, imageAttachmentsWithMediaType2[0].JobCardDocumentAttachmentId)];
                        case 2:
                            audioAttachmentId_1 = _a.sent();
                            updatedList = __spreadArray([], complaintsList, true);
                            urlconfirmation = updatedList.map(function (updatedItem) { return updatedItem.JobCardDetailId === item.JobCardDetailId ? _objectSpread(_objectSpread({}, updatedItem), {}, {
                                rejectionAudio: blobUrl,
                                rejectionAudioDuration: duration,
                                rejectionAudioAttachmentId: audioAttachmentId_1
                            }) : updatedItem; });
                            setComplaintsList(urlconfirmation);
                            setDisableSaveButton(false);
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            }); }).catch(function (error) { return console.error('Error fetching Blob:', error); });
            return [2 /*return*/];
        });
    }); };
    var onClickRemovePhotoIcon = function (item, image, itemIndex, imageIndex) { return __awaiter(void 0, void 0, void 0, function () {
        var _item$JobCardDetailId, _DeleteAttchementResp, _DeleteAttchementResp2, request, DeleteAttchementResponse, updatedList, updatedItem, updatedPhotos, updatedList, updatedItem, updatedPhotos;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!image.isAlreadyUploaded) return [3 /*break*/, 2];
                    request = {
                        "SystemName": "JobCardDetail",
                        ParentId: (_item$JobCardDetailId = item.JobCardDetailId) !== null && _item$JobCardDetailId !== void 0 ? _item$JobCardDetailId : "",
                        AttachmentId: image.attachmentId
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: deleteAllJobCardAttachmentsUrl,
                            request: request
                        }))];
                case 1:
                    DeleteAttchementResponse = _a.sent();
                    if (DeleteAttchementResponse !== null && DeleteAttchementResponse !== void 0 && (_DeleteAttchementResp = DeleteAttchementResponse.payload) !== null && _DeleteAttchementResp !== void 0 && (_DeleteAttchementResp = _DeleteAttchementResp.value) !== null && _DeleteAttchementResp !== void 0 && _DeleteAttchementResp.success && DeleteAttchementResponse !== null && DeleteAttchementResponse !== void 0 && (_DeleteAttchementResp2 = DeleteAttchementResponse.payload) !== null && _DeleteAttchementResp2 !== void 0 && (_DeleteAttchementResp2 = _DeleteAttchementResp2.value) !== null && _DeleteAttchementResp2 !== void 0 && _DeleteAttchementResp2.data) {
                        updatedList = __spreadArray([], complaintsList, true);
                        updatedItem = _objectSpread({}, updatedList[itemIndex]);
                        updatedPhotos = __spreadArray([], updatedItem.rejectionPhotos, true);
                        updatedPhotos.splice(imageIndex, 1);
                        updatedItem.rejectionPhotos = updatedPhotos;
                        updatedList[itemIndex] = updatedItem;
                        setComplaintsList(updatedList);
                        setCurrentSelectedItem(updatedItem);
                    }
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [3 /*break*/, 3];
                case 2:
                    updatedList = __spreadArray([], complaintsList, true);
                    updatedItem = _objectSpread({}, updatedList[itemIndex]);
                    updatedPhotos = __spreadArray([], updatedItem.rejectionPhotos, true);
                    updatedPhotos.splice(imageIndex, 1);
                    updatedItem.rejectionPhotos = updatedPhotos;
                    updatedList[itemIndex] = updatedItem;
                    setComplaintsList(updatedList);
                    setCurrentSelectedItem(updatedItem);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleViewAllClick = function (photos) {
        setViewAllImagesList(photos);
        setViewImages(function (prev) { return !prev; });
        // let _jobItem: any = [...jobItemList]
        // const showAllImages = _jobItem.map((item: any) =>
        //     item.ComplaintId === items.ComplaintId ? { ...item, isShowImage: !item.isShowImage } : item
        // );
        // setJobItemList(showAllImages)
        // onChange(showAllImages, groupItem);
    };
    var handleCommonPopupImageList = function (imagesList, removedImageList) {
        setCommonRejectionPhotos(imagesList);
    };
    var handleCommonAudioUrl = function (value, duration, convertedBlob) {
        setCommonRejectionAudio({
            commonRejectionAudioUrl: value,
            commonRejectionAudioDuration: duration
        });
    };
    var getSaveDisable = function () {
        return !complaintsList.every(function (item) { return item.isAprroved || item.isRejected; }) || isViewOnly || disableSaveButton;
    };
    var handleClickImage = function (url) {
        setImageURL(url);
        setISDrawerOpen(true);
    };
    var handleClose = function () {
        setImageURL("");
        setISDrawerOpen(false);
    };
    var onDeleteRecording = function (index) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedComplaintList, _updatedComplaintList, _updatedComplaintList2, request, DeleteAttchementResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatedComplaintList = __spreadArray([], complaintsList, true);
                    updatedComplaintList[index].rejectionAudio = "";
                    if (!(updatedComplaintList[index].rejectionAudioAttachmentId && updatedComplaintList[index].isAudioAlreadyUploaded)) return [3 /*break*/, 2];
                    request = {
                        "SystemName": "JobCardDetail",
                        ParentId: (_updatedComplaintList = (_updatedComplaintList2 = updatedComplaintList[index]) === null || _updatedComplaintList2 === void 0 ? void 0 : _updatedComplaintList2.JobCardDetailId) !== null && _updatedComplaintList !== void 0 ? _updatedComplaintList : "",
                        AttachmentId: updatedComplaintList[index].rejectionAudioAttachmentId
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: deleteAllJobCardAttachmentsUrl,
                            request: request
                        }))];
                case 1:
                    DeleteAttchementResponse = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    _a.label = 2;
                case 2:
                    updatedComplaintList[index].rejectionAudioAttachmentId = "";
                    updatedComplaintList[index].isAudioAlreadyUploaded = false;
                    setDisableSaveButton(false);
                    setComplaintsList(updatedComplaintList);
                    return [2 /*return*/];
            }
        });
    }); };
    var onDeleteCommonPopupRecording = function () {
        setCommonRejectionAudio({
            commonRejectionAudioDuration: 0,
            commonRejectionAudioUrl: ""
        });
    };
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1
    }, complaintsList.length > 0 ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'space-between'
    }, Module === isModuleConfig.Product && /*#__PURE__*/ React.createElement(ButtonGroup, {
        disabled: isViewOnly,
        variant: "outlined",
        "aria-label": "owener rider button group"
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        size: "medium",
        sx: {
            border: '1px solid #F5222D',
            color: '#F5222D',
            backgroundColor: getAllComplaintsStatus().isAllRejected ? '#F4F7FA' : 'transparent'
        },
        name: t("Reject all"),
        onClick: handleRejectAllComplaints,
        id: "owner-button"
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        size: "medium",
        sx: {
            border: "1px solid ".concat(bajajPrimaryBlue),
            borderLeftColor: '#F5222D',
            color: bajajPrimaryBlue,
            backgroundColor: getAllComplaintsStatus().isAllApproved ? '#F4F7FA' : 'transparent'
        },
        name: t('Approve all'),
        onClick: handleApproveAllComplaints,
        id: "rider-button"
    }))), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        rowSpacing: 2
    }, complaintsList.map(function (item, index) {
        var _item$rejectionPhotos, _item$rejectionPhotos2, _item$rejectionPhotos3, _item$rejectionAudioD;
        console.log('item', item);
        return /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            key: index
        }, /*#__PURE__*/ React.createElement(StyledStack, {
            openRejectActions: item.openRejectActions,
            isApproved: item.isAprroved,
            paddingY: 1,
            paddingX: 2,
            direction: 'column'
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            width: '100%',
            justifyContent: isInspectionMode ? 'space-between' : 'center',
            alignItems: "center"
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column'
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "pm-parts",
            variant: "h3"
        }, item.Title), /*#__PURE__*/ React.createElement(Typography, {
            id: "part-code",
            variant: "h6",
            color: 'secondary'
        }, "#".concat(item === null || item === void 0 ? void 0 : item.ChildCode))), selectMode ? /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(FormControlLabel, {
            disabled: isViewOnly,
            control: /*#__PURE__*/ React.createElement(Checkbox, null),
            label: '',
            checked: item.isSelected,
            onClick: function () {
                handleItemCheckboxClick(index);
            },
            sx: {
                margin: 0
            }
        })) : /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiIconButton, {
            id: "pm-part-approval-btn",
            size: "small",
            onClick: function () { return onClickApproveIcon(index); },
            disabled: item.isAprroved || isViewOnly
        }, /*#__PURE__*/ React.createElement("img", {
            alt: "approve",
            src: item.isAprroved || isViewOnly ? ApproveSqaureIcon : ApproveSqaureIconGreen
        })), /*#__PURE__*/ React.createElement(MuiIconButton, {
            id: "pm-part-reject-btn",
            size: "small",
            onClick: function () { return onClickRejectIcon(index); },
            disabled: item.isRejected || isViewOnly
        }, /*#__PURE__*/ React.createElement("img", {
            alt: "reject",
            src: item.isRejected || isViewOnly ? RejectSquareIcon : RejectIcon
        })))), item.openRejectActions && /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(Grid, {
            container: true
        }, item.openRejectActions && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            lg: 5.8,
            md: 5.8,
            sm: 5.8,
            xs: 12
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontSize: "14px",
            fontWeight: "600",
            color: '#1B1D21',
            marginY: '16px'
        }, t('FI Observation')), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            justifyContent: "center",
            bgcolor: 'white',
            borderRadius: '8px',
            marginTop: "16px"
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                border: '1px solid #DEE4EB',
                borderRadius: "8px 8px 0px 0px"
            },
            width: "100%"
        }, /*#__PURE__*/ React.createElement(TextField, {
            disabled: isViewOnly,
            id: "fi-observation",
            placeholder: "Enter comments",
            multiline: true,
            rows: 3,
            fullWidth: true,
            value: item.rejectionComment,
            sx: {
                "& fieldset": {
                    border: 'none'
                }
            },
            style: {
                margin: 0
            },
            onChange: function (event) {
                var _event$target$value, _event$target;
                handleComplaintData({
                    discription: (_event$target$value = event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value) !== null && _event$target$value !== void 0 ? _event$target$value : ''
                }, index);
            }
        })), /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column',
            sx: {
                border: '1px solid #DEE4EB',
                borderRadius: "0px 0px 8px 8px"
            },
            width: "100%"
        }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement("div", {
            style: {
                left: "8px",
                bottom: 10
            }
        }, /*#__PURE__*/ React.createElement(IconButton, {
            disabled: ((_item$rejectionPhotos = item.rejectionPhotos) === null || _item$rejectionPhotos === void 0 ? void 0 : _item$rejectionPhotos.length) === 3 || isViewOnly
        }, ((_item$rejectionPhotos2 = item.rejectionPhotos) === null || _item$rejectionPhotos2 === void 0 ? void 0 : _item$rejectionPhotos2.length) === 3 || isViewOnly ? /*#__PURE__*/ React.createElement(GalleryIcon, {
            sx: {
                color: systemColor.disabled
            }
        }) : /*#__PURE__*/ React.createElement(GalleryIcon, {
            sx: {
                color: systemColor.primary
            },
            onClick: function () { return handleOpenGalleryClick(item); }
        }))), /*#__PURE__*/ React.createElement("div", {
            style: {
                left: "45px",
                bottom: 10
            }
        }, /*#__PURE__*/ React.createElement(IconButton, {
            disabled: isViewOnly
        }, /*#__PURE__*/ React.createElement(AudioComponent, {
            isDisablebtn: isViewOnly,
            handleurl: function (value, duration, convertedBlob) { return handleAudioUrl(value, duration, convertedBlob, item, index); }
        })))), item.rejectionPhotos && /*#__PURE__*/ React.createElement(MuiStack, {
            paddingX: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: 'space-between',
            display: 'flex',
            alignItems: "center"
        }, item === null || item === void 0 || (_item$rejectionPhotos3 = item.rejectionPhotos) === null || _item$rejectionPhotos3 === void 0 ? void 0 : _item$rejectionPhotos3.slice(0, 3).map(function (image, photoIndex) { /*#__PURE__*/ return React.createElement(Grid, {
            item: true,
            key: photoIndex,
            xs: 4,
            sm: 6,
            md: 6,
            lg: 6
        }, /*#__PURE__*/ React.createElement("div", {
            className: "1st",
            style: {
                position: 'relative',
                display: 'inline-block'
            }
        }, !isViewOnly && /*#__PURE__*/ React.createElement(GridCloseIcon, {
            onClick: function () { return onClickRemovePhotoIcon(item, image, index, photoIndex); },
            sx: {
                position: 'absolute',
                zIndex: 1,
                right: 10,
                top: 8,
                backgroundColor: "white",
                height: '15px',
                width: '15px',
                borderRadius: 50
            }
        }), /*#__PURE__*/ React.createElement("img", {
            src: image.blobUrl,
            alt: "Image ".concat(index + 1),
            style: {
                width: '90%',
                height: '100px',
                borderRadius: '8px',
                position: 'relative',
                objectFit: 'contain',
                filter: photoIndex === 2 && (item === null || item === void 0 ? void 0 : item.rejectionPhotos.length) > 3 ? 'brightness(.5)' : 'none'
            },
            onClick: function () {
                if ((item === null || item === void 0 ? void 0 : item.rejectionPhotos.length) > 3 && photoIndex === 2) { }
                else {
                    handleClickImage(image.blobUrl);
                }
            }
        }), (item === null || item === void 0 ? void 0 : item.rejectionPhotos.length) > 3 && photoIndex === 2 && /*#__PURE__*/ React.createElement(Typography, {
            variant: "body2",
            sx: {
                position: 'absolute',
                top: '40px',
                left: '20%',
                color: '#FFFFFF',
                cursor: 'pointer'
            },
            onClick: function () { return handleViewAllClick(item.rejectionPhotos); }
        }, t("View All")))); }))), item.rejectionAudio && /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            alignItems: "center",
            justifyContent: 'space-between',
            spacing: 1,
            paddingX: 1
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 9,
            marginX: 1,
            marginY: 2,
            style: {
                border: '1px solid #DEE4EB',
                backgroundColor: '#FFFFFF',
                borderRadius: "8px",
                padding: '5px'
            }
        }, /*#__PURE__*/ React.createElement(AudioPlayer, {
            src: item === null || item === void 0 ? void 0 : item.rejectionAudio,
            isSlider: true,
            audioDuration: (_item$rejectionAudioD = item === null || item === void 0 ? void 0 : item.rejectionAudioDuration) !== null && _item$rejectionAudioD !== void 0 ? _item$rejectionAudioD : 0
        })), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 2
        }, /*#__PURE__*/ React.createElement(IconButton, {
            onClick: function () { return onDeleteRecording(index); },
            disabled: isViewOnly
        }, /*#__PURE__*/ React.createElement("img", {
            src: DeleteButtonNewIcon,
            alt: "gallery-disable",
            style: {
                width: '36px',
                height: '36px'
            }
        }))))))))));
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        justifyContent: "flex-end"
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        id: "pm-parts-save-btn",
        loading: loader.isLoaderOpen,
        disabled: getSaveDisable(),
        variant: "contained",
        name: t('Save'),
        onClick: saveDynamicChecklistValues
    }))) : /*#__PURE__*/ React.createElement(React.Fragment, null, !isShowSkeleton && /*#__PURE__*/ React.createElement(NoRowsOverlay, null)), /*#__PURE__*/ React.createElement(React.Fragment, null, isShowSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        style: {
            height: '50px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null))), isDrawerOpen && /*#__PURE__*/ React.createElement(MuiImagePopUp, {
        isOpen: isDrawerOpen,
        onClose: handleClose,
        image: imageURL
    }), /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: isOpenRejectAllPopup,
        title: parentComponent,
        variant: "h1",
        onClose: handleCloseRejectAllPopup,
        closeIcon: true,
        containerStyle: {
            width: '100%',
            padding: '2px 5px 8px 5px'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        paddingX: 2,
        paddingBottom: 1,
        direction: 'column',
        spacing: 2
    }, /*#__PURE__*/ React.createElement(Typography, null, "Job card: ", (_documentDetailsGetBy = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy2 = documentDetailsGetById.data) === null || _documentDetailsGetBy2 === void 0 ? void 0 : _documentDetailsGetBy2.Code) !== null && _documentDetailsGetBy !== void 0 ? _documentDetailsGetBy : "-"), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 2,
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        width: "100%"
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        padding: 1,
        justifyContent: "center"
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'relative',
            paddingBottom: 10
        }
    }, /*#__PURE__*/ React.createElement(TextField, {
        id: "multiline-input",
        placeholder: "Enter comments",
        multiline: true,
        rows: 4,
        fullWidth: true,
        value: commonRejectionComment,
        InputProps: {
            style: {
                borderRadius: '8px 8px 8px 8px',
                backgroundColor: '#FFFFFF',
                paddingBottom: 30
            }
        },
        style: {
            margin: 0
        },
        onChange: function (event) {
            var _event$target$value2;
            return setCommonRejectionComment((_event$target$value2 = event.target.value) !== null && _event$target$value2 !== void 0 ? _event$target$value2 : "");
        }
    }), /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'absolute',
            left: "8px",
            bottom: 15
        }
    }, /*#__PURE__*/ React.createElement(IconButton, null, /*#__PURE__*/ React.createElement(GalleryIcon, {
        sx: {
            color: systemColor.primary
        },
        onClick: function () {
            setOpenCommonImagePopup(true);
        }
    })), /*#__PURE__*/ React.createElement(ImageCapture, {
        downloadedImages: commonRejectionPhotos,
        isOpen: openCommonImagePopup,
        handleClose: function () {
            setOpenCommonImagePopup(function (prev) { return !prev; });
        },
        handleImageList: function (list, removedImageList) { return handleCommonPopupImageList(list, removedImageList); }
    })), /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'absolute',
            left: "45px",
            bottom: 15
        }
    }, /*#__PURE__*/ React.createElement(IconButton, null, /*#__PURE__*/ React.createElement(AudioComponent, {
        handleurl: function (value, duration, convertedBlob) { return handleCommonAudioUrl(value, duration, convertedBlob); }
    })))), commonRejectionAudio.commonRejectionAudioUrl && /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        alignItems: "center",
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 10
    }, /*#__PURE__*/ React.createElement(AudioPlayer, {
        src: commonRejectionAudio === null || commonRejectionAudio === void 0 ? void 0 : commonRejectionAudio.commonRejectionAudioUrl,
        isSlider: true,
        audioDuration: (_commonRejectionAudio = commonRejectionAudio.commonRejectionAudioDuration) !== null && _commonRejectionAudio !== void 0 ? _commonRejectionAudio : 0
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 2
    }, /*#__PURE__*/ React.createElement("img", {
        src: DeleteButtonNewIcon,
        alt: "gallery-disable",
        style: {
            width: '36px',
            height: '36px'
        },
        onClick: onDeleteCommonPopupRecording
    }))), commonRejectionPhotos && /*#__PURE__*/ React.createElement(MuiStack, {
        paddingX: 1,
        paddingTop: 1
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'space-between',
        display: 'flex',
        alignItems: "center"
    }, commonRejectionPhotos === null || commonRejectionPhotos === void 0 ? void 0 : commonRejectionPhotos.slice(0, 3).map(function (image, photoIndex) { /*#__PURE__*/ return React.createElement(Grid, {
        item: true,
        key: photoIndex,
        xs: 4,
        sm: 6,
        md: 6,
        lg: 6
    }, /*#__PURE__*/ React.createElement("div", {
        className: "1st",
        style: {
            position: 'relative',
            display: 'inline-block'
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: image.blobUrl,
        alt: "Image ".concat(photoIndex + 1),
        style: {
            width: '90%',
            height: '100px',
            borderRadius: '8px',
            position: 'relative',
            objectFit: 'contain',
            filter: photoIndex === 2 && commonRejectionPhotos.length > 3 ? 'brightness(.5)' : 'none'
        },
        onClick: function () { return handleClickImage(image.blobUrl); }
    }), commonRejectionPhotos.length > 3 && photoIndex === 2 && /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            position: 'absolute',
            top: '40px',
            left: '20%',
            color: '#FFFFFF',
            cursor: 'pointer'
        }
        // onClick={() => handleViewAllClick(item)}
    }, t("View All")))); }))))), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1,
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        disabled: !commonRejectionComment,
        name: t("Reject all"),
        size: "medium",
        fullWidth: true,
        variant: "contained",
        onClick: handleRejectAllPopupDataRecieved,
        sx: {
            backgroundColor: '#F5222D'
        }
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        name: t('Cancel'),
        size: "medium",
        fullWidth: true,
        onClick: handleCloseRejectAllPopup
    }))))), /*#__PURE__*/ React.createElement(ViewAllImagePopUp, {
        isOpen: viewImages,
        onClosed: function () { return setViewImages(function (prev) { return !prev; }); },
        images: viewAllImagesList
    }), /*#__PURE__*/ React.createElement(ImageCapture, {
        downloadedImages: (_currentSelectedItem$2 = currentSelectedItem === null || currentSelectedItem === void 0 ? void 0 : currentSelectedItem.rejectionPhotos) !== null && _currentSelectedItem$2 !== void 0 ? _currentSelectedItem$2 : [],
        isOpen: openImageGallery,
        handleClose: function () { return setOpenImageGallery(false); },
        handleImageList: function (list, removedImageList) { return handleImageList(list, removedImageList); }
    }));
};
export default FinalInspectorAdditionalJobs;
